import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../../config";

export function useUpdateProductPrice() {
    const queryClient = useQueryClient();
    
    return useMutation({
        mutationFn: async ({ data }) => {
            const res = await api.put(`/product/skus/update/price`, data);
            return res.data;
        },
        onSuccess: () => {
            // Invalidar cache para forçar a atualização dos dados
            queryClient.invalidateQueries(['search-products']);
        }
    });
}
export function useImportCatalog() {
    const queryClient = useQueryClient();
    
    return useMutation({
        mutationFn: async () => {
            const res = await api.post(`/product/mercadolivre/import?channel=MERCADO_LIVRE`);
            return res.data;
        },
        onSuccess: () => {
            // Invalidar cache para forçar a atualização dos dados
            queryClient.invalidateQueries(['update-catalog']);
        }
    });
}
